var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocuments1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3688 15.6938L31.5563 3.88125C31.2188 3.54375 30.8813 3.375 30.375 3.375H13.5C11.6437 3.375 10.125 4.89375 10.125 6.75V47.25C10.125 49.1063 11.6437 50.625 13.5 50.625H40.5C42.3563 50.625 43.875 49.1063 43.875 47.25V16.875C43.875 16.3687 43.7063 16.0312 43.3688 15.6938ZM30.375 7.425L39.825 16.875H30.375V7.425ZM40.5 47.25H13.5V6.75H27V16.875C27 18.7312 28.5187 20.25 30.375 20.25H40.5V47.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments1);
export default __webpack_public_path__ + "static/media/documents1.07e843f9e79fed32b31f99a7434f06d1.svg";
export { ForwardRef as ReactComponent };